// 아이템 설정
const ItemConfig = {
  DIAMOND: {
    DIAMOND_GREEN: {
      MODEL_PATH: "models/platformer/Assets/gltf/green/diamond_green.gltf",
      POINTS_VALUE: 5,
    },
    DIAMOND_BLUE: {
      MODEL_PATH: "models/platformer/Assets/gltf/blue/diamond_blue.gltf",
      POINTS_VALUE: 10,
    },
    DIAMOND_RED: {
      MODEL_PATH: "models/platformer/Assets/gltf/red/diamond_red.gltf",
      POINTS_VALUE: 20,
    },
    DIAMOND_YELLOW: {
      MODEL_PATH: "models/platformer/Assets/gltf/yellow/diamond_yellow.gltf",
      POINTS_VALUE: 40,
    },
  },
  HEART: {
    MODEL_PATH: "models/platformer/Assets/gltf/red/heart_red.gltf",
    HEAL_AMOUNT: 50,
  },
  STAR: {
    MODEL_PATH: "models/platformer/Assets/gltf/yellow/star_yellow.gltf",
  },
  BOMB: {
    MODEL_PATH: "models/platformer/Assets/gltf/neutral/bomb.gltf",
  },
  MAGNET: {
    MODEL_PATH:
      "models/platformer/Assets/gltf/blue/lever_wall_base_A_blue.gltf",
    MAGNET_SPEED: 80.0,
  },

  // 아이템 스폰 설정
  SPAWN: {
    heart: {
      spawnInterval: 60000,
      lastSpawnTime: 0,
      spawnChance: 0.5,
      maxCount: 3, // 최대 100개까지 동시 존재
    },
    magnet: {
      spawnInterval: 60000,
      lastSpawnTime: 0,
      spawnChance: 0.5,
      maxCount: 3, // 최대 100개까지 동시 존재
    },
    bomb: {
      spawnInterval: 60000,
      lastSpawnTime: 0,
      spawnChance: 0.5,
      maxCount: 3, // 최대 100개까지 동시 존재
    },
    star: {
      spawnInterval: 60000,
      lastSpawnTime: 0,
      spawnChance: 0.5,
      maxCount: 3, // 최대 100개까지 동시 존재
    },
    diamond: {
      spawnInterval: 2000,
      lastSpawnTime: 0,
      spawnChance: 1.0,
      maxCount: 20, // 최대 100개까지 동시 존재
    },
  },
};

// webpack 빌드를 위해 default export 추가
export default ItemConfig;

// 전역 변수로도 등록 (기존 코드 호환성)
window.ItemConfig = ItemConfig;
